import { SchoolsAutocompleteModel } from './models/schools-autocomplete.model';
import { FileUploadModel } from './models/file-upload.model';
import { DropdownQuestionModel } from './models/dropdown-question.model';
import { TextboxQuestionModel } from './models/textbox-question.mode';
import { CheckboxQuestionModel } from './models/checkbox-question.model';
import { SummerAppFieldTypesEnum } from 'app/shared/enums/field-types.enum';
import { QuestionBaseModel } from './models/question-base.model';
import { SsnQuestionModel } from 'app/shared/models/ssn-question.model';
import { YesNoSelectorQuestionModel } from 'app/shared/models/yes-no-selector-question.model';
import { LabelQuestionModel } from 'app/shared/models/label-question.model';

export class MapperHelper {
    static mapQuestionsFields(primaryObjects: any[]): QuestionBaseModel<any>[] {
        let result: QuestionBaseModel<any>[] = [];
        result = primaryObjects.map((i) => {
            switch (i.fieldTypeName) {
                case SummerAppFieldTypesEnum.Checkbox:
                    return new CheckboxQuestionModel(i);
                case SummerAppFieldTypesEnum.Input:
                case SummerAppFieldTypesEnum.Date:
                case SummerAppFieldTypesEnum.Numeric:
                case SummerAppFieldTypesEnum.OptionalInput:
                    return new TextboxQuestionModel(i);
                case SummerAppFieldTypesEnum.Label:
                    return new LabelQuestionModel(i);
                case SummerAppFieldTypesEnum.Dropdown:
                    return new DropdownQuestionModel(i);
                case SummerAppFieldTypesEnum.ResumeUpload:
                    return new FileUploadModel(i);
                case SummerAppFieldTypesEnum.SchoolsAutoComplete:
                    return new SchoolsAutocompleteModel(i);
                case SummerAppFieldTypesEnum.SSN:
                    return new SsnQuestionModel(i);
                case SummerAppFieldTypesEnum.YesNoSelector:
                    return new YesNoSelectorQuestionModel(i);
                default:
                    throw new Error('Unknown field type:'+i.fieldTypeName);                    
            }
        });

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/mapper-helper.ts